(() => {
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

  class LicohennaEndingVisual extends HTMLElement {
    connectedCallback() {
      this.frame = this.querySelector('.licohenna-ending-visual__frame');
      this.image = this.querySelector('.licohenna-ending-visual__image');
      this.ticking = false;
      this.rafId = 0;
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.onScrollOrResize = () => {
        if (this.ticking) return;
        this.ticking = true;
        this.rafId = requestAnimationFrame(() => {
          this.ticking = false;
          this.update();
        });
      };

      this.onMotionChange = () => this.update();

      window.addEventListener('scroll', this.onScrollOrResize, { passive: true });
      window.addEventListener('resize', this.onScrollOrResize, { passive: true });

      if (this.motionQuery.addEventListener) {
        this.motionQuery.addEventListener('change', this.onMotionChange);
      } else {
        this.motionQuery.addListener(this.onMotionChange);
      }

      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollOrResize);
      window.removeEventListener('resize', this.onScrollOrResize);

      if (this.motionQuery) {
        if (this.motionQuery.removeEventListener) {
          this.motionQuery.removeEventListener('change', this.onMotionChange);
        } else {
          this.motionQuery.removeListener(this.onMotionChange);
        }
      }

      if (this.rafId) cancelAnimationFrame(this.rafId);
    }

    travel() {
      const desired = window.matchMedia('(min-width: 700px)').matches ? 35 : 25;
      if (!this.frame || !this.image) return 0;
      const extra = (this.image.offsetHeight - this.frame.offsetHeight) / 2;
      return Math.max(0, Math.min(desired, extra - 1));
    }

    progress() {
      if (!this.frame) return 0.5;
      const rect = this.frame.getBoundingClientRect();
      const range = window.innerHeight + rect.height;
      if (range <= 0) return 0.5;
      return clamp((window.innerHeight - rect.top) / range, 0, 1);
    }

    update() {
      if (!this.image) return;

      if (this.motionQuery.matches) {
        this.image.style.transform = 'translate3d(0, -50%, 0)';
        return;
      }

      const y = (this.progress() * 2 - 1) * this.travel();
      this.image.style.transform = `translate3d(0, calc(-50% + ${y.toFixed(2)}px), 0)`;
    }
  }

  if (!customElements.get('licohenna-ending-visual')) {
    customElements.define('licohenna-ending-visual', LicohennaEndingVisual);
  }
})();
